import { render } from "./MessageBubble.vue?vue&type=template&id=39a395e0&scoped=true"
import script from "./MessageBubble.vue?vue&type=script&lang=js"
export * from "./MessageBubble.vue?vue&type=script&lang=js"

import "./MessageBubble.vue?vue&type=style&index=0&id=39a395e0&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39a395e0"]])

export default __exports__